import {Enum} from "@/utilities/enums/Enum.ts";

export const E_VirtualProject = Object.freeze({
    MAIN:"/virtual-tour",
    UD:(id:string)=> `/virtual-tour/${id}`,
    DOMAIN:"/virtual-tour/by-domain"
})

export type E_VirtualProject = Enum<typeof E_VirtualProject>